export default __webpack_public_path__ + "static/media/MonumentExtended-Bold.add92697.otf";